module.exports = __webpack_public_path__ + "static/img/privacy-7.4a6aec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-7.png
// module id = hrUp
// module chunks = 1